module.exports = __webpack_public_path__ + "img/43_3.273226d6.png";